import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {
  ConservazioneCaricaDocumentoModelloF23F24Step2Component
} from './conservazione-carica-documento-modello-f23-f24-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-modello-f23-f24-step2', {
            url: '/conservazione-carica-modello-f23-f24',
            ncyBreadcrumb: {
                label: 'Carica Modello F23 - F24',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-modello-f23-f24-step2 flex="100"></conservazione-carica-documento-modello-f23-f24-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoModelloF23F24Step2Module: string = ng
    .module('conservazione-carica-documento-modello-f23-f24-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoModelloF23F24Step2', ConservazioneCaricaDocumentoModelloF23F24Step2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-modello-f23-f24-step2/conservazione-carica-documento-modello-f23-f24-step2.module.ts